
<ng-container *ngIf="enableShoppingCart">
    <div class="nav--link-item ml--16 mr--16">
    <button mat-icon-button 
    class="nav--link nav--routelink" 
    [disabled]="!cartActive$()" 
    (click)="goTocheckout()" 
    [matTooltip]="'Proceed to checkout' | translate"
    [matTooltipDisabled]="cartItems$().length == 0">
        <span class="di di-cart" [matBadge]="cartItems$().length" [matBadgeHidden]="!cartActive$()"></span>
    </button>
    </div>
</ng-container>
